module.exports = __webpack_public_path__ + "static/media/file_upload.2f97f7fa.svg";